export default {
  requiredForDidacticBriefcase: 'Este objeto es necesario para el funcionamiento de la maleta didáctica.',
}
